import React, { useState, useEffect } from 'react';
import LegalLinks from '@/components/LegalLinks';

const TrialConfirmView = ({ onComplete }) => {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 800),   // "You're in."
      setTimeout(() => setPhase(2), 1800),  // "Your 7 day trial has begun."
      setTimeout(() => setPhase(3), 2700),  // "Nothing to charge until..."
      setTimeout(() => setPhase(4), 3800),  // Begin button
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  const fade = (threshold) => ({
    opacity: phase >= threshold ? 1 : 0,
    transition: 'opacity 1.2s ease',
  });

  return (
    <div
      data-testid="trial-confirm-view"
      style={{
        minHeight: '100vh',
        background: '#080608',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 32px',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: '360px' }}>

        {/* Breathing sphere — fades in on mount */}
        <div
          className="breathing-sphere"
          style={{
            margin: '0 auto 56px',
            boxShadow: '0 0 48px 12px rgba(196, 137, 74, 0.18), 0 0 120px 40px rgba(196, 137, 74, 0.07)',
            opacity: 1,
            transition: 'opacity 2s ease',
          }}
        />

        {/* Line 1 */}
        <p style={{
          ...fade(1),
          fontFamily: "'Cormorant', Georgia, serif",
          fontStyle: 'italic',
          fontWeight: 400,
          fontSize: '30px',
          color: 'rgba(255, 243, 225, 0.88)',
          letterSpacing: '-0.01em',
          margin: '0 0 24px',
        }}>
          You're in.
        </p>

        {/* Line 2 */}
        <p style={{
          ...fade(2),
          fontFamily: "'Cormorant', Georgia, serif",
          fontStyle: 'italic',
          fontWeight: 400,
          fontSize: '18px',
          color: 'rgba(255, 243, 225, 0.55)',
          lineHeight: 1.7,
          margin: '0 0 8px',
        }}>
          Your 7 day trial has begun.
        </p>

        {/* Line 3 */}
        <p style={{
          ...fade(3),
          fontFamily: "'Cormorant', Georgia, serif",
          fontStyle: 'italic',
          fontWeight: 400,
          fontSize: '18px',
          color: 'rgba(255, 243, 225, 0.40)',
          lineHeight: 1.7,
          margin: '0 0 52px',
        }}>
          No payment needed to start.
        </p>

        {/* Begin button */}
        <div style={fade(4)}>
          <button
            onClick={onComplete}
            className="velvet-btn"
            data-testid="trial-confirm-begin"
            style={{
              fontFamily: "'EB Garamond', Georgia, serif",
              fontSize: '17px',
              letterSpacing: '0.02em',
              maxWidth: '200px',
              margin: '0 auto',
              display: 'block',
            }}
          >
            Begin
          </button>
          <LegalLinks style={{ marginTop: '24px' }} />
        </div>

      </div>
    </div>
  );
};

export default TrialConfirmView;
